import { FC } from "react";
import { HospitalFeedbackCompetitionWidget } from "pages/Metrics/components";
import { MetricsDateRange } from "pages/Metrics/metricsDateRange";

type Props = {
  orgId?: string | null;
  dateRange: MetricsDateRange;
};

/** Home-facing wrapper around the hospital competition widget. */
export const HospitalFeedbackCompetition: FC<Props> = ({
  orgId,
  dateRange,
}) => (
  <HospitalFeedbackCompetitionWidget orgId={orgId} dateRange={dateRange} />
);
